import type { ComponentProps } from "react";
import { Link } from "react-router";

import {
  NewTabWarning,
  getNewTabTitle,
} from "metabase/common/components/ExternalLink";
import CS from "metabase/css/core/index.css";
import { useSelector } from "metabase/redux";
import type { State } from "metabase/redux/store";
import { getDocsUrl } from "metabase/selectors/settings";

export const MarkdownLink = ({ href, children }: ComponentProps<"a">) => {
  const parsedUrl = useSelector((state) => getParsedMDLinkUrl(state, href));

  return (
    <Link
      to={parsedUrl}
      className={CS.link}
      target="_blank"
      title={getNewTabTitle()}
    >
      {children}
      <NewTabWarning />
    </Link>
  );
};

const getParsedMDLinkUrl = (state: State, href?: string) => {
  if (href?.includes(".md") && !href?.startsWith("http")) {
    const relativeDocPath = href.replace(".md", "");
    const finalPath = `databases/connections/${relativeDocPath}`;
    return getDocsUrl(state, { page: finalPath });
  }

  return href || "";
};
